import { TenderlySimulation } from '../model';
import { TenderlySimulationDto, TenderlySimulationResponseDto } from '../dto';

export class TenderlySimulationFactory {
  public static createFromTenderlyDto(
    dto: TenderlySimulationResponseDto,
    tenderlyAccount: string,
    tenderlyProject: string,
  ): TenderlySimulation {
    const result = new TenderlySimulation();
    result.id = dto.simulation.id;
    result.status = dto.simulation.status;
    result.errorMessage = dto.simulation.error_message;
    result.blockNumber = dto.simulation.block_number;
    result.gas = dto.simulation.gas;
    result.gasUsed = dto.simulation.gas_used;
    result.url = `https://dashboard.tenderly.co/${tenderlyAccount}/${tenderlyProject}/simulator/${result.id}`;
    return result;
  }

  public static createFromBackendDto(
    dto: TenderlySimulationDto,
  ): TenderlySimulation {
    const result = new TenderlySimulation();
    result.id = dto.tenderlyId;
    result.status = dto.status;
    result.errorMessage = dto.errorMessage;
    result.blockNumber = dto.blockNumber;
    result.gas = dto.gas;
    result.gasUsed = dto.gasUsed;
    result.url = dto.url;
    return result;
  }
}
